import React from "react"
import { Container } from "react-bootstrap"
import { Link } from 'gatsby'
import image1 from '../images/01a.jpg'
import image2 from '../images/02a.jpg'
import image3 from '../images/03a.jpg'
import Layout from "../components/layout"
import SEO from "../components/seo"
import Masthead from '../components/masthead'



const IndexPage = () => (
  <Layout pageInfo={{ pageName: "index" }}>
    <SEO title="Schüleraustausch und Networking" keywords={[`schueleraustausch`, `meetup`]} />
    <Masthead />

    <section>
      <Container>
        <div className='row align-items-center'>
          <div className="col-lg-6">
            <div className="p-5">
              <h2 className="display-4">Sei mit dabei!</h2>
              <p>
                26. September | 11:00 – 15:00 | Online
              </p>
              <p>
                Das X-CHANGE Meetup ist die perfekte Vorbereitung für dein Auslandsjahr. Lass dich inspirieren und informiere dich zu deinem persönlichen Schüleraustausch. Bekannte Mitglieder der X-CHANGE Community werden Einblicke in ihre Auslandsjahr-Erfahrungen geben und freuen sich deine Frage im Livestream zu beantworten.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="p-5">
              <img className="img-fluid rounded-circle" src={image1} alt="" />
            </div>
          </div>

        </div>
      </Container>
    </section>

    <section>
      <Container>
        <div className='row align-items-center'>
          <div className="col-lg-6">
            <div className="p-5">
              <img className="img-fluid rounded-circle" src={image2} alt="" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="p-5">
              <h2 className="display-4">We are a community!</h2>
              <p>
                <strong>Du interessierst dich für ein Auslandsjahr?</strong><br />
                Wir laden dich beim virtuellen X-CHANGE Meetup dazu ein, dich mit aktuellen und ehemaligen Austauschschülern und Austauschschülerinnen persönlich auszutauschen. Ziel des X-CHANGE Meetup ist es, dir wichtige Tipps mit auf den Weg zu geben, die du für die Planung deines eigenen Auslandsjahres brauchst. Außerdem wollen wir mit dir in Kontakt kommen! Stell uns deine Fragen und tausche dich mit anderen Community Mitgliedern im Chat aus. Sieh dir das <Link to='/lineup/'>Line-up</Link> an.
              </p>
              <p>
                Die Teilnahme ist für dich natürlich kostenlos. Wir freuen uns auf dich!
              </p>
            </div>
          </div>
        </div>
      </Container>
    </section>

    <section>
      <Container>
        <div className='row align-items-center'>

          <div className="col-lg-6">
            <div className="p-5">
              <h2 className="display-4">Programm & Ablauf</h2>
              <p>
                Am <strong>26.09.2021</strong> kannst du von <strong>11:00 - 15:00</strong> Uhr
                am X-CHANGE Meetup teilnehmen.
              </p>
              <dl className="mb-4">
                <dt>11:00 - 12:00 Uhr | Livestream</dt>
                <dd>Begrüßung und Impressionen aus dem Schüleraustausch</dd>
                <dt>
                  12:00 - 13:00 Uhr | Zoom-Meetings
                </dt>
                <dd>Persönlicher Austausch mit bekannten Community Mitgliedern</dd>
              </dl>
              <dl>
                <dt>11:00 - 15:00 Uhr | Zoom-Meeting
                </dt><dd>Deine Fragen an die Austauschorganisationen
                </dd>
              </dl>
              <p>
                <Link to="/programm/" className="btn btn-primary rounded-pill">zum Online-Event</Link>
              </p>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="p-5">
              <img className="img-fluid rounded-circle" src={image3} alt="" />
            </div>
          </div>
        </div>
      </Container>
    </section>

  </Layout>
)

export default IndexPage
